import appLost from "../../views/lostView.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("lost", {
    url: "lost",
    parent: "app",
    views: {
      view: {
        template: appLost,
      },
    },
    reloadOnSearch: false,
    data: { title: "Lost" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/lost/lost.urls.js